'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$4() {
  this.bi3 = null;
  this.bi1 = null;
  this.bi2 = false;
  this.bhZ = null;
  this.bi0 = false;
  this.bi4 = false;
  this.bi5 = false;
  this.bi3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$4 as $c_Lpresto_PrestoRouter$$anon$4 };
$p = $c_Lpresto_PrestoRouter$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$4;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$4() {
}
export { $h_Lpresto_PrestoRouter$$anon$4 as $h_Lpresto_PrestoRouter$$anon$4 };
$h_Lpresto_PrestoRouter$$anon$4.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bi3;
});
$p.t = (function() {
  if ((!this.bi2)) {
    this.bi1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bi2 = true;
  }
  return this.bi1;
});
$p.ae = (function() {
  if ((!this.bi0)) {
    this.bhZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bi0 = true;
  }
  return this.bhZ;
});
$p.w = (function() {
  if ((!this.bi5)) {
    this.bi4 = false;
    this.bi5 = true;
  }
  return this.bi4;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$4, "presto.PrestoRouter$$anon$4", ({
  O6: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$4 as $d_Lpresto_PrestoRouter$$anon$4 };
//# sourceMappingURL=presto.-Presto-Router$$anon$4.js.map
